export const getStyles = (token) => ({
    modal: {
      borderRadius: token.borderRadiusLG,
      overflow: "hidden",
    },
    warningIcon: {
      width: 48,
      height: 48,
      margin: "0 auto 24px",
      background: token.colorFillTertiary,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalTitle: {
      fontSize: "24px",
      lineHeight: 1.2,
      fontWeight: token.fontWeightStrong,
      color: token.colorText,
      marginBottom: "16px",
    },
    bodyContent: {
      padding: `0 ${token.paddingXS}px`,
    },
    contentContainer: {
      marginBottom: "32px",
    },
    messageText: {
      fontSize: token.fontSize,
      lineHeight: 1.2,
      color: token.colorText,
    },
    listingName: {
      fontSize: token.fontSize,
      lineHeight: 1.5,
      color: token.colorText,
      fontWeight: 700
    },
    warningText: {
      fontSize: "14px",
      lineHeight: 1.5,
      color: token.colorText,
      display: "block",
    },
    buttonContainer: {
      display: "flex",
      gap: token.marginSM,
      alignItems: "center",
    },
    cancelButton: {
      padding: `${token.paddingSM}px ${token.paddingLG}px`,
      borderRadius: token.borderRadiusXL,
      border: `1px solid ${token.colorPrimary}`,
      color: token.colorPrimary,
      fontWeight: token.fontWeightMedium,
      fontSize: token.fontSizeSM,
      lineHeight: 1.2,
      height: 44,
      boxShadow: token.boxShadowSecondary,
      transition: `all ${token.motionDurationMid}`,
      "&:hover": {
        background: token.colorPrimary,
        borderColor: token.colorPrimary,
        color: token.colorWhite,
      },
    },
    deleteButton: {
      padding: `${token.paddingSM}px ${token.paddingLG}px`,
      borderRadius: token.borderRadiusXL,
      background: token.colorError,
      border: "none",
      color: token.colorWhite,
      fontWeight: token.fontWeightMedium,
      fontSize: token.fontSizeSM,
      lineHeight: 1.2,
      height: 44,
      boxShadow: token.boxShadowSecondary,
      transition: `all ${token.motionDurationMid}`,
      "&:hover": {
        background: token.colorErrorHover,
        borderColor: token.colorErrorHover,
        color: token.colorWhite,
      },
    },
  });